import React, {useEffect, useState} from 'react'
import {Form, Formik} from "formik";
import {InputField} from "../../InputField";
import FormGroup from "../../FormGroup";
import manufacturerService from "../../../../../services/manufacturerService";
import GenericCanvasActions from "../../../UI/Canvas/GenericCanvasActions";
import GenericOffCanvas from "../../../UI/Canvas/GenericOffCanvas";
import {manufacturerForm} from "./manufacturerForm";
import {toast} from "react-toastify";

const ManufacturerOffCanvas = ({isOpen, toggle, data, handleResponse}) => {

    const [initialValues, setInitialValues] = useState(manufacturerForm.initialValues)
    const handleSubmit = (values) => data ? manufacturerService.update(data.uuid, values) : manufacturerService.store(values);

    useEffect(() => {
        data ? setInitialValues({
            name: data.name || '',
            description: data.description || '',
            note: data.note || '',
        }) : setInitialValues(manufacturerForm.initialValues)
    }, [data]);

    return (
        <GenericOffCanvas
            title={data ? 'Modifica ' + data.name : 'Crea casa automobilistica'}
            isOpen={isOpen}
            toggle={toggle}>
            <Formik
                initialValues={initialValues}
                validationSchema={manufacturerForm.validation}
                enableReinitialize={true}
                onSubmit={(values, {setSubmitting}) => {
                    handleSubmit(values)
                        .then(res => {
                            toast.success('Operazione eseguita con successo')
                            handleResponse(res)
                            toggle(false)
                        })
                        .catch(err => toast.error(err.response.data.message))
                        .finally(() => setSubmitting(false))
                }}>
                {() => (
                    <Form>
                        <FormGroup name="name" label="Nome" required={true} inline={false}>
                            <InputField name="name" type="text" maxLength={100}/>
                        </FormGroup>
                        <FormGroup name="description" label="Descrizione" required={false}
                                   inline={false}>
                            <InputField name="description" type="text"/>
                        </FormGroup>
                        <FormGroup name="note" label="Note" required={false} inline={false}>
                            <InputField name="note" component="textarea" rows={6}/>
                        </FormGroup>
                        <GenericCanvasActions toggle={toggle}/>
                    </Form>
                )}
            </Formik>
        </GenericOffCanvas>
    )

}


export default ManufacturerOffCanvas